import React from 'react'
import { Card, CardContent, CardHeader, Skeleton, Stack, Box } from "@mui/material"

const DocumentHeaderSkeleton = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Card sx={{ borderRadius: 0, boxShadow: 'none', bgcolor: 'transparent', pb: 2 }}>
                <CardHeader
                    sx={{ pb: 1 }}
                    title={
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Skeleton variant="circular" width={32} height={32} />
                            <Skeleton variant="text" width={200} height={40} />
                        </Stack>
                    }
                    action={
                        <Stack direction="row" spacing={1} sx={{ mr: 1 }}>
                            <Stack direction="row" spacing={1}>
                                <Skeleton variant="rectangular" width={40} height={32} sx={{ borderRadius: 1 }} />
                                <Skeleton variant="rectangular" width={40} height={32} sx={{ borderRadius: 1 }} />
                            </Stack>
                            <Stack direction="row" spacing={1}>
                                <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1.5 }} />
                                <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1.5 }} />
                                <Skeleton variant="rectangular" width={130} height={32} sx={{ borderRadius: 1.5 }} />
                            </Stack>
                            <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: 1.5 }} />
                        </Stack>
                    }
                />
                <CardContent sx={{ px: 3, pt: 0 }}>
                    <Stack direction="row" flexWrap="wrap" gap={3}>
                        {Array.from({ length: 8 }).map((_, index) => (
                            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Skeleton variant="text" width={60} height={20} />
                                <Skeleton variant="text" width={100} height={20} />
                            </Box>
                        ))}
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    )
}

export default DocumentHeaderSkeleton
